import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function NotFoundPage() {
  return (
    <div data-testid="not-found-page" className="bg-[#0A0A0A] min-h-[70vh] flex flex-col items-center justify-center px-6 py-24 text-center">
      <SEO title="Page Not Found | AERWEAR" description="This page doesn't exist or has moved." noindex />
      <p className="text-xs uppercase tracking-[0.3em] text-[#8A8A8A]">404</p>
      <h1 className="mt-5 text-2xl sm:text-4xl font-medium uppercase tracking-[0.18em] text-[#F2F0EB]">Page Not Found</h1>
      <p className="mt-5 text-[15px] text-[#C9C7C2]">This page doesn't exist or has moved.</p>
      <div className="mt-10 flex flex-col sm:flex-row gap-3">
        <Link to="/shop/men" data-testid="not-found-shop" className="bg-[#F2F0EB] text-[#0A0A0A] px-8 py-3.5 font-['Oswald'] text-[11px] uppercase tracking-[0.25em] font-semibold hover:bg-[#8A8A8A] transition-colors">
          Shop
        </Link>
        <Link to="/" data-testid="not-found-home" className="border border-[#8A8A8A]/40 text-[#F2F0EB] px-8 py-3.5 font-['Oswald'] text-[11px] uppercase tracking-[0.25em] font-semibold hover:border-[#F2F0EB] transition-colors">
          Home
        </Link>
      </div>
    </div>
  );
}
